export interface SearchState {
    query: string,
}

export default {
    namespaced: true,
    state: {
        query: '',
    } as SearchState,
    getters: {
    },
    mutations: {
        SET_QUERY(state:SearchState, query:string) {
         state.query = query
        }
    },
    actions: {
        RESET_SEARCH({ commit }: { commit: Function }){
            commit('SET_QUERY', '')
        },
        SET_SEARCH({ commit }: { commit: Function}, payload: { search:SearchState }) {
            commit('SET_QUERY', payload.search.query)
        }
    }
}